import React from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  Card,
  CardBody,
  Button,
  Progress,
} from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
//react-redux comm
import { connect } from "react-redux";
import { store, authHeader } from "../../_helpers";
import SearchPanel from "./search-panel";
import PaginatedResult from "./search-result";
import ManifestDetails from "./manifest.details";
import ToolTipItem from "../utils/tooltip";

// styling
import "./style.css";

import {
  commonActions,
  apiActions,
  modalActions,
  alertActions,
} from "../../_actions";
import { appConstants, commonConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";

import DeleteIcon from "react-icons/lib/md/delete-forever";
import PdfIcon from "react-icons/lib/md/picture-as-pdf";
import ExcelIcon from "react-icons/lib/md/insert-drive-file";
import ReportIcon from "react-icons/lib/md/airplanemode-active";

import ManifestDelete from "./manifest-delete";
import { commonService } from "../../_services";
import { operationsService } from "../../_services/operations.service";

function setCategories() {
  let activeUser = appHelpers.getActiveUser();
  return activeUser.AirlineCode === null
    ? [
        { label: "Airline", value: "AirlineCode" },
        { label: "Date Type", value: "DateType" },
        { label: "Departure", value: "DepartureCode" },
        { label: "Destination", value: "DestinationCode" },
        { label: "Route Type", value: "RouteType" },
        { label: "Flight Number", value: "FlightNumber" },
      ]
    : [
        { label: "Date Type", value: "DateType" },
        { label: "Departure", value: "DepartureCode" },
        { label: "Destination", value: "DestinationCode" },
        { label: "Route Type", value: "RouteType" },
        { label: "Flight Number", value: "FlightNumber" },
      ];
}

const DateTypes = [
  { label: "Flight Date", value: 1, cat: "DateType" },
  { label: "Submitted Date", value: 2, cat: "DateType" },
];

const RouteTypes = [
  { label: "International", value: "International", cat: "RouteType" },
  { label: "Domestic", value: "Domestic", cat: "RouteType" },
];

const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">Manifest Search</h1>
      <p className="mb-0 subtitle text-nowrap">
        Manifest details &nbsp;
        <span className="hidden-sm-down">&amp; insights</span>
      </p>
    </header>
  </div>
);

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeUser: null,
      startDate: new Date(),
      endDate: new Date(),
      catOptions: [],
      searchOptions: [],
      searchArray: [{ label: "Flight Date", value: 1, cat: "DateType" }],
      searchLabelKey: "",
      searchValueKey: "",
      routeTypes: RouteTypes,
      dateTypes: DateTypes,
      airlines: [],
      flights: [],
      searchFlightNumbers: [],
      desAirports: [],
      selectValue: { label: "Date Type", value: "DateType" },
      depAirports: [],
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true,
      },
      //modal
      modal: false,
      manifestDeleteModal: false,
      modalClass: "",
      //
      manifests: false,
      manifestsCount: 0,
      passengerDetails: false,
      pageSize: 10,
      currentPage: 1,
      totalFlightCounts: 1,
      manifestInfo: false,
      clickBD: false,
      manifestLink: "#",
      airlineSelectNotification: null,
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //    Fetch Airlines
    const reduxState = store.getState();
    if (reduxState.airlinesCarriers) {
      this.setState({
        airlines: this.formatAirlines(reduxState.airlinesCarriers.Results),
      });
    } else {
      this.fetchAirlines();
    }
    // Fetch Destination Airports
    if (reduxState.desAirports) {
      this.setState({
        desAirports: this.formatDestinationAirports(
          reduxState.desAirports.Results
        ),
      });
    } else {
      this.fetchDesAirports();
    }
    // Fetch Departure Airports
    if (reduxState.depAirports) {
      this.setState({
        depAirports: this.formatDepartureAirports(
          reduxState.depAirports.Results
        ),
      });
    } else {
      this.fetchDepAirports();
    }
    //Get today's manifests results
    this.handleCatChange({ label: "Date Type", value: "DateType" });
    // this.setState({activeUser: appHelpers.getActiveUser()});
    this.search();

    const catOptions = setCategories();
    this.setState({ catOptions });

    // console.log('UAC Mount', appHelpers.getActiveUser());
  }

  componentWillReceiveProps = function (nextProps) {
    const { modal } = nextProps;
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass,
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass,
        });
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { clickBD } = this.state;
    if (clickBD) {
      this.search(1);
      this.setState({ clickBD: false });
    }
  }

  //update selected category
  updateCatValue = (newValue) => {
    this.setState({
      selectValue: newValue,
    });
    this.handleCatChange(newValue);
  };

  // check if an airline has been selected
  isAirlineSelected = (searchArray) => {
    const isAirline = searchArray.find((item) => {
      return item.cat === "AirlineCode";
    });
    return isAirline ? true : false;
  };

  //populate the multi search options with appropriate category options
  handleCatChange = (option) => {
    const { searchArray } = this.state;
    if (option) {
      // incase all category options are remove
      switch (option.value) {
        case "AirlineCode":
          return this.setState({
            searchOptions: this.state.airlines,
            searchLabelKey: "label",
            searchValueKey: "value",
            airlineSelectNotification: null,
          });
        case "DateType":
          return this.setState({
            searchOptions: this.state.dateTypes,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "DepartureCode":
          return this.setState({
            searchOptions: this.state.depAirports,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "DestinationCode":
          return this.setState({
            searchOptions: this.state.desAirports,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "RouteType":
          return this.setState({
            searchOptions: this.state.routeTypes,
            searchLabelKey: "label",
            searchValueKey: "value",
          });
        case "FlightNumber":
          return this.setState({
            searchOptions: this.state.searchFlightNumbers,
            searchLabelKey: "label",
            searchValueKey: "value",
            airlineSelectNotification: this.isAirlineSelected(searchArray)
              ? null
              : "Select an airline to fetch flight numbers",
          });
        default:
          return this.state;
      }
    }
    return this.setState({ searchOptions: [] });
  };

  // remove option if option in that category is already selected
  switchOptionsPerCategory = (currentArray, newArray, category) => {
    let newRecord = newArray.filter((x) => !currentArray.includes(x));
    if (newRecord.length !== 0 && newRecord[0].cat === "AirlineCode") {
      this.fetchAirlineFlightNumbers(newRecord[0].Id);
    }

    const { selectValue } = this.state;
    let currentCat = category ? category : selectValue;
    let optionToReplace = currentArray.filter(
      (option) => option.cat === currentCat.value
    )[0];
    // console.log("optionToReplace: " + optionToReplace);

    if (optionToReplace) {
      return newArray.filter(
        (option) => option.label !== optionToReplace.label
      );
    } else {
      return newArray;
    }
  };

  //update selected options categories
  handleSelectChange = (newValue, category) => {
    let currentArray = this.state.searchArray;

    //debugger;
    let newArray =
      currentArray.length > 0
        ? this.switchOptionsPerCategory(
            this.state.searchArray,
            newValue,
            category
          )
        : newValue;
    this.setState({ searchArray: newArray });
  };

  fetchAirlines = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        const { airlinesCarriers } = this.props;
        this.setState({
          airlines: this.formatAirlines(airlinesCarriers.Results),
        });
        //this.formatAirlines(res.data.Results);
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        // console.log('Error', error);
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  fetchAirlineFlightNumbers = (airlineId) => {
    const { dispatch } = this.props;
    dispatch(apiActions.startRequest());
    this.setState({ searchFlightNumbers: [] });
    commonService.getAirlinesFlightNumbers(airlineId).then((res) => {
      let response = res.response;
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.setState({
          searchFlightNumbers: this.formatFlightNumbers(response.Results),
        });
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(apiActions.endRequest());
      }
    });
  };

  fetchDesAirports = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getDesAirports())
      .then(() => {
        const airports = this.props.desAirports;
        let desAirports = airports.Results;
        desAirports = this.formatDestinationAirports(desAirports);
        this.setState({
          desAirports,
        });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  fetchDepAirports = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getDepAirports())
      .then(() => {
        const airports = this.props.depAirports;
        //
        let depAirports = airports.Results;
        depAirports = this.formatDepartureAirports(depAirports);
        this.setState({
          depAirports,
        });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  formatAirlines = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "AirlineCode";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Code;
      data.push(item);
    }

    return data;
  };
  formatFlightNumbers = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "FlightNumber";
      item["label"] = item.FlightNumber;
      item["value"] = item.FlightNumber;
      data.push(item);
    }

    return data;
  };

  formatSearchParameters = (res) => {
    const activeUser = appHelpers.getActiveUser();
    if (res.length > 0) {
      let searchParameters = {};
      res.map(
        (parameter) => (searchParameters[parameter.cat] = parameter.value)
      );
      /*Cater for Airline Users */
      if (activeUser.AirlineCode != null) {
        searchParameters.AirlineCode = activeUser.AirlineCode;
      }
      return searchParameters;
    }
    return {};
  };

  formatDestinationAirports = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "DestinationCode";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Code;
      data.push(item);
    }

    return data;
  };

  formatDepartureAirports = (res) => {
    let data = [];

    for (let item of res) {
      item["cat"] = "DepartureCode";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Code;
      data.push(item);
    }

    return data;
  };

  handleAirlineBD = (res) => {
    const { airlines, catOptions } = this.state;
    let category = catOptions.filter(
      (option) => option.value === "AirlineCode"
    )[0];
    let thisAirline = airlines.filter((option) => option.Name === res.Name)[0];
    if (thisAirline) {
      let searchArray = this.state.searchArray.filter(
        (option) => option.cat !== thisAirline.cat
      );
      searchArray.push(thisAirline);
      this.updateCatValue(category);
      this.handleSelectChange(searchArray, category);
      this.setState({ clickBD: true });
    } else {
      this.notify(
        `${res["Name"]} does not exist in airlines`,
        appConstants.NOTIFY_ERROR
      );
    }
  };

  handleDepBD = (res) => {
    const { depAirports, catOptions } = this.state;
    let category = catOptions.filter(
      (option) => option.value === "DepartureCode"
    )[0];
    let thisAirport = depAirports.filter(
      (option) => option.Code === res.Name
    )[0];
    let searchArray = this.state.searchArray.filter(
      (option) => option.cat !== thisAirport.cat
    );
    searchArray.push(thisAirport);
    this.updateCatValue(category);
    this.handleSelectChange(searchArray, category);
    this.setState({ clickBD: true });
  };

  handleDesBD = (res) => {
    const { desAirports, catOptions } = this.state;
    let category = catOptions.filter(
      (option) => option.value === "DestinationCode"
    )[0];
    let thisAirport = desAirports.filter(
      (option) => option.Code === res.Name
    )[0];
    let searchArray = this.state.searchArray.filter(
      (option) => option.cat !== thisAirport.cat
    );
    searchArray.push(thisAirport);
    this.updateCatValue(category);
    this.handleSelectChange(searchArray, category);
    this.setState({ clickBD: true });
  };

  handleRouteBD = (res) => {
    const { catOptions } = this.state;
    let category = catOptions.filter(
      (option) => option.value === "RouteType"
    )[0];
    let thisRoute = RouteTypes.filter((option) => option.label === res.Name)[0];
    let searchArray = this.state.searchArray.filter(
      (option) => option.cat !== thisRoute.cat
    );
    searchArray.push(thisRoute);

    this.updateCatValue(category);
    this.handleSelectChange(searchArray, category);

    this.setState({ clickBD: true });
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
  }

  resetModal() {
    this.setState({
      passengerDetails: false,
      manifestInfo: false,
      componentError: false,
      componentErrorMessages: [],
    });
    this.resetError();
  }

  onRemove = (notification) => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded =
      this._notificationSystem.addNotification(notification);
  };

  search = (pageNumber) => {
    const { dispatch } = this.props;
    const { searchArray, pageSize, startDate, endDate } = this.state;
    this.setState({ contentError: false });
    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      pageNumber = 1;
    } else {
      dispatch(apiActions.startRequest());
    }

    let fromPage = pageSize * (pageNumber - 1);

    // if((pageNumber - 1) > 0) {
    //     fromPage = 1;
    // }
    let searchParams = this.formatSearchParameters(searchArray);

    let payload = {
      PageSize: pageSize,
      From: fromPage,
      Parameter: {
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
        ...searchParams,
      },
    };
    let payloadStringify = JSON.stringify(payload);

    let url = appConstants.PAS_URL + "/api/manifest/multisearch";
    appHelpers
      .postRequest(url, payloadStringify, authHeader())
      .then((res) => {
        this.setState({
          manifests: res.data.Manifests.Items.length > 0 ? res.data : false,
          currentPage: pageNumber,
        });
        dispatch(apiActions.endRequest());
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        //dispatch(alertActions.error(errorMessage));
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
        this.setState({ contentError: errorMessage });
      });
  };

//   showManifest = (manifest) => {
//     const { dispatch } = this.props;

//     this.setState({ manifestInfo: manifest });
//     let url =
//       appConstants.PAS_URL +
//       "/api/manifest/Passengers_v2?manifestId=" +
//       manifest.ManifestId;

//     dispatch(apiActions.startRequest());
//     appHelpers
//       .getRequest(url)
//       .then((res) => {
//         this.setState({
//           passengerDetails: res.data,
//         });
//         dispatch(apiActions.endRequest());

//         let url =
//           appConstants.PAS_URL +
//           "/api/manifest/download?manifestid=" +
//           manifest.ManifestId;

//         dispatch(apiActions.startRequest());
//         appHelpers
//           .getBinaryRequest(url)
//           .then((res) => {
           
//             this.setState({
//               manifestLink: res.data,
//             });
//             dispatch(apiActions.endRequest());
//             this.toggle(null, "modalSlideIn");
//           })
//           .catch((error) => {
//             let errorMessage = appHelpers.interpretErrorResponse(error);
//             this.notify(errorMessage, appConstants.NOTIFY_ERROR);
//             dispatch(apiActions.endRequest());
//           });
//       })
//       .catch((error) => {
//         let errorMessage = appHelpers.interpretErrorResponse(error);
//         this.notify(errorMessage, appConstants.NOTIFY_ERROR);
//         dispatch(apiActions.endRequest());
//       });
//   };

showManifest = (manifest) => {
    const { dispatch } = this.props;
  
    this.setState({ manifestInfo: manifest });
    const url =
      appConstants.PAS_URL +
      "/api/manifest/Passengers_v2?manifestId=" +
      manifest.ManifestId;
  
    dispatch(apiActions.startRequest());
  
    appHelpers
      .getRequest(url)
      .then((res) => {
        this.setState({
          passengerDetails: res.data,
        });
  
        dispatch(apiActions.endRequest());
        // ✅ Just open the modal now
        this.toggle(null, "modalSlideIn");
      })
      .catch((error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
      });
  };
  
  downloadMoreDetailsManifest = (manifestId) => {
      const {dispatch} = this.props;

      operationsService.moreDetailManifestDownload(manifestId).then((res) => {
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          // let response = res.response.data.File;
          let response = res.response.data;
          
  
          const isBase64 = response.base64File ? true : false;
          const fileData = response.base64File || response; // filestream is in response directly
          // const mimeType = response.type || "application/pdf";
          // normalize mime type
          let mimeType = response.type || "application/pdf";
          if (mimeType === "application/xls") {
            mimeType = "application/vnd.ms-excel"; // correct for old .xls
          }
          appHelpers.downloadFileV2(
            fileData,
            "Manitest_details",
            isBase64,
            mimeType
          );
          // window.open(response, "_blank");
          dispatch(apiActions.endRequest());
        } else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          dispatch(apiActions.endRequest());
        }
      });
  
      dispatch(apiActions.startRequest());
  }

  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetModal();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  toggleDeleteModal = (e, modalClass) => {
    const currManifestDeleteModalState = this.state.manifestDeleteModal;
    this.setState({
      manifestDeleteModal: !currManifestDeleteModalState,
      modalClass: modalClass,
    });
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  downloadReport = (downloadType) => {
    const { dispatch } = this.props;
    const { startDate, endDate, searchArray } = this.state;
    let searchParams = this.formatSearchParameters(searchArray);

    const payload__ = {
      StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
      EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
      ...searchParams,
    };

    dispatch(apiActions.startRequest());
    commonService.downloadManifest(payload__, downloadType).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let response = res.response.data;
       

        const isBase64 = response.base64File ? true : false;
        const fileData = response.base64File || response; // filestream is in response directly
        // const mimeType = response.type || "application/pdf";
        // normalize mime type
        let mimeType = response.type || "application/pdf";
        if (mimeType === "application/xls") {
          mimeType = "application/vnd.ms-excel"; // correct for old .xls
        }
        appHelpers.downloadFileV2(
          fileData,
          "Manifest_Report",
          isBase64,
          mimeType
        );
        // window.open(response.File, '_blank');
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  render() {
    let modalResponse = this.renderPageResponse();
    const {
      catOptions,
      selectValue,
      searchOptions,
      searchLabelKey,
      searchValueKey,
      searchArray,
      contentError,
      currentPage,
      pageSize,
      manifests,
      modal,
      modalClass,
      passengerDetails,
      manifestInfo,
      manifestLink,
      airlineSelectNotification,
    } = this.state;
    const { requesting, pageRequesting, desAirports } = this.props;
    const userRole = appHelpers.getActiveUser().AviRole;
    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody>
                <h6 className="mb-0 text-uppercase pull-left">Search Panel</h6>
                {/* <div className="mb-0 text-uppercase pull-right">
                                    {
                                        userRole === appConstants.ROLES.VGG_ADMIN &&
                                        <Button className="btn-avi-secondary" onClick={(e) => this.toggleDeleteModal(e, 'modalSlideIn')}>
                                            <DeleteIcon color="#ffffff" size="16" />&nbsp;Delete Manifest
                                        </Button>
                                    }
                                </div> */}
                <div className="clearfix">&nbsp;</div>
                <SearchPanel
                  categories={catOptions}
                  selectedCat={selectValue}
                  multiOptions={searchOptions}
                  multiLabelKey={searchLabelKey}
                  multiValueKey={searchValueKey}
                  multiArray={searchArray}
                  onCatValueChange={this.updateCatValue}
                  onMultiValueChange={this.handleSelectChange}
                  onSearch={this.search}
                  startDateChange={(startDate) => this.setState({ startDate })}
                  endDateChange={(endDate) => this.setState({ endDate })}
                  airlineSelectNotification={airlineSelectNotification}
                />
                <hr />

                {/*Files to Be downloaded */}
                {!pageRequesting && manifests && (
                  <Container>
                    <Row className="pl-2 pr-2">
                      <Col xs="6" sm="6">
                        <h5 className="font-weight-normal mb-0">
                          <ReportIcon size="22" color="#43a8df" />
                          {appHelpers.numberWithCommasOnly(
                            manifests.ManifestCount.ItemValue
                          )}{" "}
                          records matched
                        </h5>
                      </Col>
                      <Col xs="6" sm="6">
                        <div className="text-right">
                          <strong>Reports: </strong>
                          <span
                            className="pointer"
                            onClick={() =>
                              this.downloadReport(
                                commonConstants.PDF_DOWNLOAD_TYPE
                              )
                            }
                          >
                            <ToolTipItem
                              key={"downloadPdfIcon"}
                              title={
                                <PdfIcon
                                  size="18"
                                  color="#e53335"
                                  className="icon-picture-as-pdf"
                                />
                              }
                              content="Download PDF"
                              id={"downloadPdfIcon"}
                            />
                          </span>
                          &nbsp;
                          <span
                            className="pointer"
                            onClick={() =>
                              this.downloadReport(
                                commonConstants.EXCEL_DOWNLOAD_TYPE
                              )
                            }
                          >
                            <ToolTipItem
                              key={"downloadExcelIcon"}
                              title={
                                <ExcelIcon
                                  size="18"
                                  color="#5ead57"
                                  className="icon-insert-drive-file"
                                />
                              }
                              content="Download Excel"
                              id={"downloadExcelIcon"}
                            />
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                )}
                <CardBody>
                  {!pageRequesting && manifests && (
                    <div>
                      <PaginatedResult
                        manifestResults={manifests}
                        currentPage={currentPage}
                        navigate={this.search}
                        pageSize={pageSize}
                        totalCount={manifests.ManifestCount.ItemValue}
                        showManifest={this.showManifest}
                        handleAirlineBD={this.handleAirlineBD}
                        handleDepBD={this.handleDepBD}
                        handleDesBD={this.handleDesBD}
                        handleRouteBD={this.handleRouteBD}
                        airports={desAirports}
                      />
                    </div>
                  )}
                  {!pageRequesting && !manifests && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
                  {passengerDetails && (
                    <ManifestDetails
                      isOpen={modal}
                      toggle={this.toggle}
                      modalClass={modalClass}
                      modalResponse={modalResponse}
                      details={passengerDetails}
                      info={manifestInfo}
                      downloadManifest={() =>
                        this.downloadMoreDetailsManifest(manifestInfo.ManifestId)
                      }
                    //   downloadManifest={manifestLink}
                    />
                  )}

                  <Modal
                    size={"lg"}
                    isOpen={this.state.manifestDeleteModal}
                    toggle={this.toggleDeleteModal}
                    className={this.state.modalClass}
                  >
                    <ModalHeader toggle={this.toggleDeleteModal}>
                      Delete Manifest
                    </ModalHeader>
                    <ManifestDelete
                      airlines={this.state.airlines}
                      flights={this.state.flights}
                      toggleModal={this.toggleDeleteModal}
                    />
                  </Modal>
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    airlinesCarriers: state.airlinesCarriers,
    desAirports: state.desAirports,
    depAirports: state.depAirports,
    requesting: state.api.requesting,
    pageRequesting: state.api.pageRequesting,
    modal: state.modal,
  };
}

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./src/views/search/index.js